export const getGamesComponent =
    (component: keyof typeof import('./games.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "games" */
            './games.chunk'
        );
        return chunk[component];
    };
